import { LinearGradient } from 'expo-linear-gradient'
import type { INativebaseConfig } from 'native-base'

export const nativeBaseConfig: INativebaseConfig = {
  dependencies: {
    'linear-gradient': LinearGradient,
  },
}
